const BASE_API =
  process.env.REACT_APP_BASE_API || "https://cms-api.i.movider.co/v1";
const AUTH = "auth";
const PAYMENT = "payment";
const PAYMENTLOG = "payment_log";
const REFUND = "refund";
const SERVICE_STATUS = "service_status";
const MATCH_COUNTRY_GATEWAY = "match_country_gateway";
const MEMBER = "member";
const MEMBER_SELL_PRICE = "member-rates";
const ADMIN = "admin";
const ADMIN_ROLE = "admin-role";
const VERIFY_TEMPLATE = "verify_template";
const COUNTRY = "country";
const COUNTRY_RESTRICTIONS = "country_restrictions";
const MEMBER_COUNTRY_RESTRICTIONS = "member_country_restrictions";
const COUNTRY_SELL_PRICE = "rates";
const HOME = "home";
const GATEWAY_COUNTRY = "gateway_country";
const GATEWAY_COUNTRY_LOGS = "gateway_country_logs";
const GATEWAY = "gateway";
const VBL_GATEWAY = "vbl_gateway";
const KYC = "kyc";
const KYC_ADMIN_REASON = "kyc_admin_reason";
const DELIVERY_LOGS = "delivery_logs";
const DELIVERY_LOGS_VERIFY = "delivery_logs_verify";
const KEYWORD_BLACKHOLE = "keyword-blackhole";
const KEYWORD_ALERT_BLACKLIST = "keyword-alert/blacklist";
const KEYWORD_ALERT_WHITELIST = "keyword-alert/whitelist";
const KEYWORD_ALERT_WHITELIST_MEMBER = "keyword-alert-whitelist-member";
const DELIVERY_LOGS_BLACKHOLE = "delivery-logs-blackhole";
const DN_LOGS = "dn-logs";
const SENDERS = "senders";
const SENDERS_POOL = "senders-pool";
const BASE_NWC_URL =
  process.env.REACT_APP_BASE_NWC_URL || "https://dashboard.movider.co";
const COOKIES_DOMAIN = process.env.REACT_APP_COOKIES_DOMAIN || ".movider.co";
const COOKIES_TOKEN = process.env.REACT_APP_COOKIES_TOKEN || "MVD_token";
const COOKIES_OLD_TOKEN =
  process.env.REACT_APP_COOKIES_OLD_TOKEN || "MVD_old_token";
const COOKIES_TOKEN_STEALTH =
  process.env.REACT_APP_COOKIES_TOKEN_STEALTH || "MVD_stealth";

const SMS_LOGS_API = "sl-api";
const SMS_LOGS_CAMPAIGN = "sl-campaign";
const SMS_LOGS_SMPP = "sl-smpp";
const SMS_LOGS_VIBER = "vbl-campaign";

const BLACKLIST = "blacklist";
const REVISION_PRICE = "revision-price";
const COST_PRICE = "cost-price";
const MEMBER_COUNTRY = "forbidden-country";
const SALES_BINDING = "sbr";
const SENDER_ALLOW = "senders-allow";

const Constant = {
  BASE_API: BASE_API,

  AUTH_API: `${BASE_API}/${AUTH}`,

  PAYMENT_API: `${BASE_API}/${PAYMENT}`,
  PAYMENT_APPROVE_API: `${BASE_API}/${PAYMENT}/[id]/confirm`,
  PAYMENT_REJECT_API: `${BASE_API}/${PAYMENT}/[id]/reject`,
  PAYMENT_LOG_API: `${BASE_API}/${PAYMENTLOG}`,

  REFUND_API: `${BASE_API}/${REFUND}`,
  REFUND_ENABLE_OUTBOUND: `${BASE_API}/${REFUND}/[id]/enable/outbound`,
  REFUND_DISABLE_OUTBOUND: `${BASE_API}/${REFUND}/[id]/disable/outbound`,

  SERVICE_STATUS_API: `${BASE_API}/${SERVICE_STATUS}`,
  SERVICE_STATUS_ENABLE: `${BASE_API}/${SERVICE_STATUS}/[id]/enable`,
  SERVICE_STATUS_DISABLE: `${BASE_API}/${SERVICE_STATUS}/[id]/disable`,
  SERVICE_STATUS_EDIT: `${BASE_API}/${SERVICE_STATUS}/[id]`,
  SERVICE_STATUS_DELETE: `${BASE_API}/${SERVICE_STATUS}/[id]`,

  MATCH_COUNTRY_GATEWAY_API: `${BASE_API}/${MATCH_COUNTRY_GATEWAY}`,

  MEMBER_API: `${BASE_API}/${MEMBER}`,
  MEMBER_SEARCH: `${BASE_API}/member-find`,
  MEMBER_INVITE_AGAIN_API: `${BASE_API}/${MEMBER}/[id]/invite-again`,
  MEMBER_DELETE_API: `${BASE_API}/${MEMBER}/[id]`,
  MEMBER_ADD_CREDIT_API: `${BASE_API}/${MEMBER}/[id]/add-credit`,
  MEMBER_LOGS_API: `${BASE_API}/${MEMBER}/[id]/logs`,

  MEMBER_SELL_PRICE_API: `${BASE_API}/${MEMBER_SELL_PRICE}`,
  MEMBER_SELL_PRICE_EDIT: `${BASE_API}/${MEMBER_SELL_PRICE}/[id]`,
  MEMBER_SELL_PRICE_DELETE: `${BASE_API}/${MEMBER_SELL_PRICE}/[id]`,
  MEMBER_SELL_PRICE_DISABLE: `${BASE_API}/${MEMBER_SELL_PRICE}/[id]/disabled`,
  MEMBER_SELL_PRICE_ENABLE: `${BASE_API}/${MEMBER_SELL_PRICE}/[id]/enabled`,

  DELIVERY_LOGS_API: `${BASE_API}/${DELIVERY_LOGS}`,
  DELIVERY_LOGS_VERIFY_API: `${BASE_API}/${DELIVERY_LOGS_VERIFY}`,

  ADMIN_API: `${BASE_API}/${ADMIN}`,
  ADMIN_LOGOUT_API: `${BASE_API}/${ADMIN}/logout`,
  ADMIN_SET_PASSWORD: `${BASE_API}/${ADMIN}/set_password`,
  ADMIN_MY_CHANGE_PASSWORD: `${BASE_API}/${ADMIN}/change_password`,
  ADMIN_GETALL_API: `${BASE_API}/${ADMIN}/all`,

  ADMIN_MY_PROFILE: `${BASE_API}/${ADMIN}/me`,

  ADMIN_EDIT_API: `${BASE_API}/${ADMIN}/[id]`,
  ADMIN_ENABLE_API: `${BASE_API}/${ADMIN}/[id]/enable`,
  ADMIN_DISABLE_API: `${BASE_API}/${ADMIN}/[id]/disable`,
  ADMIN_INVITE_AGAIN_API: `${BASE_API}/${ADMIN}/[id]/invite_again`,

  ADMIN_ROLE_API: `${BASE_API}/${ADMIN_ROLE}`,

  VERIFY_TEMPLATE_API: `${BASE_API}/${VERIFY_TEMPLATE}`,
  VERIFY_TEMPLATE_EDIT_API: `${BASE_API}/${VERIFY_TEMPLATE}/[id]`,
  VERIFY_TEMPLATE_ENABLE_API: `${BASE_API}/${VERIFY_TEMPLATE}/[id]/enable`,
  VERIFY_TEMPLATE_DISABLE_API: `${BASE_API}/${VERIFY_TEMPLATE}/[id]/disable`,

  COUNTRY_API: `${BASE_API}/${COUNTRY}`,

  COUNTRY_RESTRICTIONS_API: `${BASE_API}/${COUNTRY_RESTRICTIONS}`,
  COUNTRY_RESTRICTIONS_EDIT_API: `${BASE_API}/${COUNTRY_RESTRICTIONS}/[id]`,

  REVISION_PRICE_API: `${BASE_API}/${REVISION_PRICE}`,
  REVISION_PRICE_BY_ID_API: `${BASE_API}/${REVISION_PRICE}/[id]`,
  REVISION_PRICE_NEXT_VERSION_API: `${BASE_API}/${REVISION_PRICE}/info-next-version`,
  REVISION_PRICE_CHANGE_LOGS_API: `${BASE_API}/${REVISION_PRICE}/[id]/change-logs`,

  COST_PRICE_API: `${BASE_API}/${COST_PRICE}`,
  COST_PRICE_GATEWAY_COUNTRY_API: `${BASE_API}/${COST_PRICE}/[id]`,
  COST_PRICE_GATEWAY_API: `${BASE_API}/${COST_PRICE}/[id]/gateway`,
  COST_PRICE_CHANGE_LOGS_API: `${BASE_API}/${COST_PRICE}/[id]/change-logs`,
  COST_COMPARE_API: `${BASE_API}/${COST_PRICE}/[id]/comparison`,

  MEMBER_COUNTRY_RESTRICTIONS_API: `${BASE_API}/${MEMBER_COUNTRY_RESTRICTIONS}`,
  MEMBER_COUNTRY_RESTRICTIONS_EDIT_API: `${BASE_API}/${MEMBER_COUNTRY_RESTRICTIONS}/[id]`,
  MEMBER_COUNTRY_RESTRICTIONS_ENABLE_API: `${BASE_API}/${MEMBER_COUNTRY_RESTRICTIONS}/[id]/enable`,
  MEMBER_COUNTRY_RESTRICTIONS_DISABLE_API: `${BASE_API}/${MEMBER_COUNTRY_RESTRICTIONS}/[id]/disable`,

  COUNTRY_SELL_PRICE_API: `${BASE_API}/${COUNTRY_SELL_PRICE}`,
  COUNTRY_SELL_PRICE_EDIT_API: `${BASE_API}/${COUNTRY_SELL_PRICE}/[id]`,

  HOME_API: `${BASE_API}/${HOME}`,

  GATEWAY_COUNTRY_API: `${BASE_API}/${GATEWAY_COUNTRY}`,
  GATEWAY_COUNTRY_API_ENABLE_API: `${BASE_API}/${GATEWAY_COUNTRY}/[id]/enabled`,
  GATEWAY_COUNTRY_API_DISABLE_API: `${BASE_API}/${GATEWAY_COUNTRY}/[id]/disabled`,
  GATEWAY_COUNTRY_API_DELETED_API: `${BASE_API}/${GATEWAY_COUNTRY}/[id]/deleted`,

  GATEWAY_COUNTRY_LOGS_API: `${BASE_API}/${GATEWAY_COUNTRY_LOGS}`,

  BLACKLIST_API: `${BASE_API}/${BLACKLIST}`,

  GATEWAY_API: `${BASE_API}/${GATEWAY}`,
  VBL_GATEWAY_API: `${BASE_API}/${VBL_GATEWAY}`,
  OTT_TRANSACTION_API: `${BASE_API}/ott/transaction`,

  KYC_API_RESUBMIT: `${BASE_API}/${KYC}/[id]/resubmit`,

  KYC_ADMIN_REASON_API: `${BASE_API}/${KYC_ADMIN_REASON}`,

  KEYWORD_BLACKHOLE_API: `${BASE_API}/${KEYWORD_BLACKHOLE}`,

  KEYWORD_ALERT_BLACKLIST_API: `${BASE_API}/${KEYWORD_ALERT_BLACKLIST}`,

  KEYWORD_ALERT_WHITELIST_API: `${BASE_API}/${KEYWORD_ALERT_WHITELIST}`,

  KEYWORD_ALERT_WHITELIST_MEMBER_API: `${BASE_API}/${KEYWORD_ALERT_WHITELIST_MEMBER}`,

  DELIVERY_LOGS_BLACKHOLE_API: `${BASE_API}/${DELIVERY_LOGS_BLACKHOLE}`,

  DN_LOGS_API: `${BASE_API}/${DN_LOGS}`,

  SENDERS_API: `${BASE_API}/${SENDERS}`,
  SENDERS_API_DEFAULT: `${BASE_API}/${SENDERS}/default`,
  SENDERS_API_DEFAULT_HIGHEST: `${BASE_API}/${SENDERS}/default-highest`,
  SENDERS_API_ENABLED: `${BASE_API}/${SENDERS}/[id]/enabled`,
  SENDERS_API_DISABLED: `${BASE_API}/${SENDERS}/[id]/disabled`,
  SENDERS_API_EDIT_DEFAULT: `${BASE_API}/${SENDERS}/[id]/default`,
  SENDERS_API_EDIT_DEFAULT_HIGHEST: `${BASE_API}/${SENDERS}/[id]/default-highest`,
  SENDERS_API_SET_DEFAULT: `${BASE_API}/${SENDERS}/[id]/set-default`,

  SENDERS_POOL_API: `${BASE_API}/${SENDERS_POOL}`,
  SENDERS_POOL_API_ENABLED: `${BASE_API}/${SENDERS_POOL}/[id]/enabled`,
  SENDERS_POOL_API_DISABLED: `${BASE_API}/${SENDERS_POOL}/[id]/disabled`,

  SL_API: `${BASE_API}/${SMS_LOGS_API}`,
  SL_CAMPAIGN: `${BASE_API}/${SMS_LOGS_CAMPAIGN}`,
  SL_SMPP: `${BASE_API}/${SMS_LOGS_SMPP}`,
  SL_RAW: (col) => `${BASE_API}/sl-raw/${col}`,
  VBL_CAMPAIGN: `${BASE_API}/${SMS_LOGS_VIBER}`,

  SessionKey: "myToken",
  MyNameKey: "myName",
  InviteTokenKey: "inviteToken",

  BASE_NWC_URL: BASE_NWC_URL,
  COOKIES_DOMAIN: COOKIES_DOMAIN,
  COOKIES_TOKEN: COOKIES_TOKEN,
  COOKIES_OLD_TOKEN: COOKIES_OLD_TOKEN,
  COOKIES_TOKEN_STEALTH: COOKIES_TOKEN_STEALTH,

  MEMBER_COUNTRY_API: `${BASE_API}/${MEMBER_COUNTRY}`,

  SALES_BINDING_API: `${BASE_API}/${SALES_BINDING}`,

  TABLE_SMS_LOGS: {
    API: SMS_LOGS_API,
    CAMPAIGN: SMS_LOGS_CAMPAIGN,
    SMPP: SMS_LOGS_SMPP,
    VIBER_CAM: SMS_LOGS_VIBER,
  },

  MEMBER_SENDERS_ALLOW_API: `${BASE_API}/${SENDER_ALLOW}`,

  // Member Credit Wallet CRUD
  MEMBER_CREDIT_WALLET_CREATE: `${BASE_API}/member-credit-wallet`,
  MEMBER_CREDIT_WALLET_UPDATE_CREDIT: `${BASE_API}/member-credit-wallet/[id]/credit`,
  MEMBER_CREDIT_WALLET_TRANSFER: `${BASE_API}/member-credit-wallet/[id]/transfer`,
  MEMBER_CREDIT_WALLET_TRANSFER_TO_BALANCE: `${BASE_API}/member-credit-wallet/[id]/transfer-to-balance`,
  MEMBER_CREDIT_WALLET_EXTEND: `${BASE_API}/member-credit-wallet/[id]/extend`,
  MEMBER_CREDIT_WALLET_DELETE: `${BASE_API}/member-credit-wallet/[id]`,
  MEMBER_CREDIT_WALLET_LOGS: `${BASE_API}/member-credit-wallet/[id]/logs`,
  MEMBER_WALLET_ALL_LOGS: `${BASE_API}/wallet-activity-logs/[member_id]`,
  PRODUCT_PACKAGES: `${BASE_API}/product-packages`,
  PRODUCT_PACKAGES_TRIAL: `${BASE_API}/product-packages/trial`,
  PRODUCT_PACKAGE_BY_ID: `${BASE_API}/product-package/[id]`,
};

export { Constant };



// WEBPACK FOOTER //
// ./src/config/index.js